export default __webpack_public_path__ + "static/strapi-business-partner-f25ed5192333bd592572361abcd51720.png";